import { type SVGProps } from "react"
import { IconBase } from "./IconBase"

export function ClockFettIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props} viewBox="0 0 572 572">
      <circle
        id="outer-circle"
        cx="286"
        cy="286"
        r="214.444"
        style={{
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 25,
        }}
      />
      <circle id="inner-dot" cx="286" cy="286" r="38.082" />
      <path
        d="M163.207 286H286V101.81"
        style={{
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 25,
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
        }}
      />
    </IconBase>
  )
}
